import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import OrganizationsMultiSelect from "@/components/v2/molecules/admin/tabs/AdminDashboardTab/OrganizationsMultiSelect";
import PropertiesMultiSelect from "@/components/v2/molecules/admin/tabs/AdminDashboardTab/PropertiesMultiSelect";
import BaseFilters from "@/components/v2/molecules/admin/shared/BaseFilters";
import { BUSINESS_INCOME_TYPES } from "@/constants/businessIncomes";

interface BusinessIncomeFiltersProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedOrganizations: string[];
  setSelectedOrganizations: (ids: string[]) => void;
  selectedProperties: string[];
  setSelectedProperties: (ids: string[]) => void;
  selectedIncomeType: string;
  setSelectedIncomeType: (type: string) => void;
  startDate?: Date;
  setStartDate: (date?: Date) => void;
  endDate?: Date;
  setEndDate: (date?: Date) => void;
  organizations: any[];
  filteredPropertiesForCascade: any[];
  hasActiveFilters: boolean;
  clearFilters: () => void;
}

const BusinessIncomeFilters = ({
  searchTerm,
  setSearchTerm,
  selectedOrganizations,
  setSelectedOrganizations,
  selectedProperties,
  setSelectedProperties,
  selectedIncomeType,
  setSelectedIncomeType,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  organizations,
  filteredPropertiesForCascade,
  hasActiveFilters,
  clearFilters,
}: BusinessIncomeFiltersProps) => {
  const handleDateRangeChange = (from: Date | undefined, to: Date | undefined) => {
    setStartDate(from);
    setEndDate(to);
  };

  return (
    <BaseFilters
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      searchPlaceholder="Buscar por descripción..."
      dateFrom={startDate}
      dateTo={endDate}
      onDateRangeChange={handleDateRangeChange}
      hasActiveFilters={hasActiveFilters}
      onClearFilters={clearFilters}
    >
      <OrganizationsMultiSelect
        organizations={organizations}
        selectedOrganizations={selectedOrganizations}
        onSelectionChange={setSelectedOrganizations}
      />

      <PropertiesMultiSelect
        properties={filteredPropertiesForCascade}
        selectedProperties={selectedProperties}
        onSelectionChange={setSelectedProperties}
      />

      <Select value={selectedIncomeType} onValueChange={setSelectedIncomeType}>
        <SelectTrigger className="w-[200px] rounded-full bg-gray-100 hover:bg-gray-200 transition-colors border-0">
          <SelectValue placeholder="Tipo de ingreso" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los tipos</SelectItem>
          {BUSINESS_INCOME_TYPES.map((type) => (
            <SelectItem key={type} value={type}>
              {type}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </BaseFilters>
  );
};

export default BusinessIncomeFilters;

